import { Toaster as Sonner, type ToasterProps, toast } from "sonner"

import { useTheme } from "@repo/ui/components/theming/theme-provider"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--popover)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster, toast }
